/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const MovePayMoney = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        d="M22.391 9.11L23 9.58537V22.9514H1V9.58537L1.608 9.11L2.755 10.117L12 18.4424L21.247 10.119L22.391 9.11ZM21.5 11.9094L12 20.4604L2.5 11.9094V21.4504H21.5V11.9094ZM12.564 6.7164V7.5354C13.671 7.7244 14.391 8.44439 14.445 9.48839H13.077C13.005 9.09239 12.618 8.7144 11.988 8.7144C11.448 8.7144 11.124 8.93039 11.124 9.29939C11.124 9.63239 11.376 9.7944 11.754 9.9024L12.735 10.1724C13.671 10.4424 14.481 10.8654 14.481 12.1704C14.481 13.2054 13.743 13.9344 12.564 14.0874V14.9514H11.421V14.0604C10.269 13.8444 9.504 13.0074 9.45 11.8014H10.818C10.872 12.4224 11.394 12.9084 12.06 12.9084C12.654 12.9084 13.059 12.6294 13.059 12.2064C13.059 11.8374 12.762 11.6214 12.366 11.5044L11.394 11.2344C10.467 10.9824 9.693 10.5144 9.693 9.3084C9.693 8.4084 10.395 7.7244 11.421 7.5354V6.7164H12.564ZM12 1L21.188 8.171L20.041 9.178L12 2.9024L3.958 9.178L2.811 8.171L12 1Z"
                        fill={color}
                    />
                </svg>
        );
    };
